export default {
    animation: {
        type: [Boolean, Object],
        default: undefined
    }, 
    autoBind: {
        type: Boolean,
        default: undefined
    }, 
    autoScroll: {
        type: Boolean,
        default: undefined
    }, 
    checkboxes: {
        type: [Boolean, Object],
        default: undefined
    }, 
    dataImageUrlField: {
        type: String,
        default: undefined
    }, 
    dataSource: {
        type: [Object, Array],
        default: undefined
    }, 
    dataSpriteCssClassField: {
        type: String,
        default: undefined
    }, 
    dataTextField: {
        type: [String, Array],
        default: undefined
    }, 
    dataUrlField: {
        type: String,
        default: undefined
    }, 
    dragAndDrop: {
        type: Boolean,
        default: undefined
    }, 
    loadOnDemand: {
        type: Boolean,
        default: undefined
    }, 
    messages: {
        type: Object,
        default: undefined
    }, 
    template: {
        type: [String, Function],
        default: undefined
    }, 

    // Events
    change: Function, 
    check: Function, 
    collapse: Function, 
    dataBound: {
        type: Function,
        default: undefined
    },  
    drag: Function, 
    dragend: {
        type: Function,
        default: undefined
    },  
    dragstart: {
        type: Function,
        default: undefined
    },  
    drop: Function, 
    expand: Function, 
    navigate: Function, 
    select: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-treeview-vue-wrapper/src/KendoTreeView/TreeViewProps.js